import { Component, OnInit } from '@angular/core';
import { InspectionService } from 'src/app/services/inspection/inspection.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Purchaseheader } from 'src/app/model/purchaseheader.model';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-mdcc',
  templateUrl: './mdcc.component.html',
  styleUrls: ['./mdcc.component.css']
})
export class MDCCComponent implements OnInit {
data:any;
vModelData:Purchaseheader;
  constructor(private inspectionservice:InspectionService, private router:Router,
    private route:ActivatedRoute) { }

  ngOnInit() {
    debugger;
    this.getPurchaseOrderList();
  }
  getPurchaseOrderList(){
    debugger;
    this.inspectionservice.GetPurchaseOrderList().subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
      }
    );
  }
  SubmitMDCC(form : NgForm){
    
  }
}
